var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "cards-container" }, [
            _c("div", { staticClass: "title" }, [_vm._v("Card with Image")]),
            _vm._v(" "),
            _c("div", { staticClass: "col-4" }, [
              _c(
                "div",
                { staticClass: "cards-block" },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "mb-2",
                      staticStyle: { "max-width": "20rem" },
                      attrs: {
                        title: "Card with Image",
                        "img-src":
                          "http://localhost:8080/static/images/cardsimg.jpg",
                        "img-alt": "Image",
                        "img-top": "",
                        tag: "article"
                      }
                    },
                    [
                      _c("p", { staticClass: "card-text" }, [
                        _vm._v(
                          "\n                                Some quick example text to build on the card title and make up the bulk of the card's content.\n                            "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        { attrs: { href: "#", variant: "primary" } },
                        [_vm._v("Read More")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-4" }, [
              _c(
                "div",
                { staticClass: "cards-block" },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "mb-2",
                      staticStyle: { "max-width": "20rem" },
                      attrs: {
                        title: "Card with Image",
                        "img-src":
                          "http://localhost:8080/static/images/cardsimg.jpg",
                        "img-alt": "Image",
                        "img-top": "",
                        tag: "article"
                      }
                    },
                    [
                      _c("p", { staticClass: "card-text" }, [
                        _vm._v(
                          "\n                                Some quick example text to build on the card title and make up the bulk of the card's content.\n                            "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        { attrs: { href: "#", variant: "primary" } },
                        [_vm._v("Read More")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-4" }, [
              _c(
                "div",
                { staticClass: "cards-block" },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "mb-2",
                      staticStyle: { "max-width": "20rem" },
                      attrs: {
                        title: "Card with Image",
                        "img-src":
                          "http://localhost:8080/static/images/cardsimg.jpg",
                        "img-alt": "Image",
                        "img-top": "",
                        tag: "article"
                      }
                    },
                    [
                      _c("p", { staticClass: "card-text" }, [
                        _vm._v(
                          "\n                                Some quick example text to build on the card title and make up the bulk of the card's content.\n                            "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        { attrs: { href: "#", variant: "primary" } },
                        [_vm._v("Read More")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header-top-container" }, [
      _c("div", { staticClass: "page-name" }, [_vm._v("Loading Spinner")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loading-container" }, [
      _c("div", { staticClass: "loading" }, [
        _c("img", { attrs: { src: "/static/images/loading.gif" } })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-352478a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-352478a8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading-spinner.vue
// module id = null
// module chunks = 